import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
	component: RouteComponent,
	beforeLoad: async () => {
		throw redirect({ to: "/app" });
	},
});

function RouteComponent() {
	return <div>You will be redirected.</div>;
}
